

const Footer = () => {
  return (
    <>
        <footer className="container">
          <hr />
          <span className="copyright">2022 © Todos os direitos reservados.</span>
        </footer>
    </>
  )
}

export default Footer